import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Box, Button, Checkbox, Group, Modal, Stack, Text, Title } from "@mantine/core";
import { IconDownload } from "@tabler/icons-react";
import { useMe, useDismissTopic } from "../api/queries/auth";
import {
  getDismissAndroidPopupCookie,
  isAndroidWeb,
  setDismissAndroidPopupCookie,
  shouldShowAndroidPopup,
} from "../platform/androidPopup";

export function AndroidDownloadModal() {
  const { t } = useTranslation();
  const { data: me } = useMe();
  const dismissMutation = useDismissTopic();
  const [closed, setClosed] = useState(false);
  const [dontShowAgain, setDontShowAgain] = useState(false);

  const isAndroid = isAndroidWeb();
  const cookieDismissed = getDismissAndroidPopupCookie();
  const meDismissed = me?.dismissals?.includes("android_popup");

  const visible =
    !closed &&
    shouldShowAndroidPopup({
      isAndroid,
      cookieDismissed,
      meDismissed,
    });

  if (!visible) return null;

  const handleDismiss = () => {
    if (dontShowAgain) {
      setDismissAndroidPopupCookie();
      if (me) {
        dismissMutation.mutate("android-popup");
      }
    }
    setClosed(true);
  };

  return (
    <Modal
      opened
      onClose={handleDismiss}
      withCloseButton
      centered
      radius="md"
      padding="lg"
      size="sm"
      styles={{
        content: {
          backgroundColor: "var(--mantine-color-default)",
          border: "1px solid var(--mantine-color-default-border)",
        },
      }}
    >
      <Stack align="center" gap="md">
        <Box
          component="img"
          src="/android-promo.png"
          alt=""
          aria-hidden="true"
          style={{ width: "100%", maxHeight: 180, objectFit: "contain" }}
        />

        <Stack gap={4} align="center" ta="center">
          <Title order={2} fz="xl" fw={700}>
            {t("androidPopup.title")}
          </Title>
          <Text fz="sm" c="dimmed" px="xs">
            {t("androidPopup.description")}
          </Text>
        </Stack>

        <Button
          component="a"
          href="/api/downloads/android/latest"
          download
          color="accent"
          size="md"
          fullWidth
          leftSection={<IconDownload size={20} stroke={2} aria-hidden="true" />}
          onClick={handleDismiss}
        >
          {t("androidPopup.download")}
        </Button>

        <Group justify="center" w="100%">
          <Checkbox
            label={t("androidPopup.dontShowAgain")}
            checked={dontShowAgain}
            onChange={(event) => setDontShowAgain(event.currentTarget.checked)}
            size="sm"
            color="accent"
          />
        </Group>
      </Stack>
    </Modal>
  );
}
